import { Component, OnInit, OnDestroy } from '@angular/core';
import { CartService, OrderService, ProductService } from '../../../../services';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import * as CartStore from '../../../../store/cart';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { BaseComponent, ORDER_BY_VALUE } from 'src/app/core';
import { Cart, CartListDto } from '../../../../dto';
import { SELECT_PRODUCT_STORE_NAME } from 'src/app/store/select-product';
import { Location } from '@angular/common';

@Component({
  selector: 'app-my-cart',
  templateUrl: './my-cart.component.html',
  styleUrls: ['./my-cart.component.scss'],
})
export class MyCartComponent extends BaseComponent implements OnInit, OnDestroy {
  cartCounts = 0;

  carts: Cart[];

  total = { summary: 0, quantity: 0 };
  cartLayer = false;
  isCartPage = false;

  constructor(
    private cartService: CartService,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private orderService: OrderService,
    private productServcie:ProductService,
    location: Location
  ) {
    super();
    this.store
      .select(CartStore.CART_STORE_NAME)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((state) => {
        this.getCart();
      });
  }

  ngOnInit() {
    if (location.pathname === '/cart') {
      this.isCartPage = true;
    }
  }

  override ngOnDestroy(): void {
    this.isAlive = false;
  }

  getCart() {
    this.cartService
      .getCartItems(new CartListDto().setSort(CartService.ORDER_BY[0].value, ORDER_BY_VALUE[1]))
      .subscribe((paginatedCart) => {
        this.carts = paginatedCart.items && paginatedCart.items.map((item) => new Cart(item));
        this.productServcie.cartsProductLength = this.carts.length;
        this.caculateSummaryTotal();
      });
  }

  goToCart() {
    if (this.router.url !== '/cart') {
      this.gtmService.pushTag({
        event: 'gaEvent',
        category: 'cart',
        action: 'Click Cart',
        label: 'User Cart Counts',
        data: this.cartCounts,
      });
      this.router.navigateByUrl('/cart');
    }
  }

  caculateSummaryTotal() {
    this.total = this.orderService.caculateCartsTotal(this.carts);
  }
}
